import React from 'react';

import NavComponent from './NavComponent';
import HeaderComponent from './HeaderComponent';

import './HeaderNavComponent.scss';

class HeaderNavComponent extends React.Component {
    render() {
        return (
            <div className="entete" id="entete">
                <div className="flex-container-v">
                    <HeaderComponent />
                    <NavComponent />
                </div>
            </div>
        );
    }
}

export default HeaderNavComponent;



// WEBPACK FOOTER //
// ./src/components/header/HeaderNavComponent.js